var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w1200"},[_c('h2',[_vm._v(_vm._s(_vm.info.honorTitle))]),_c('p',{staticClass:"time"},[_vm._v("发布日期："+_vm._s(_vm.info.createTime))]),_c('div',{staticClass:"lawFirmHonorsDetails",domProps:{"innerHTML":_vm._s(_vm.info.contents)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }